import type { IconProps } from '../types/IconProps.ts';
export const Minus: IconProps = {
    name: 'Minus',
    children: [
        `<path d="M5 12h14" />`,
    ]
};